import * as React from 'react';
import classNames from 'classnames';

import { IconButton } from '@fluentui/react/lib/Button';
import MaximizeRegular from 'owa-fluent-icons-svg/lib/icons/MaximizeRegular';
import SubtractRegular from 'owa-fluent-icons-svg/lib/icons/SubtractRegular';
import DismissRegular from 'owa-fluent-icons-svg/lib/icons/DismissRegular';
import RestoreRegular from 'owa-fluent-icons-svg/lib/icons/RestoreRegular';
import loc from 'owa-localize';
import { windows_Minimize } from 'owa-locstrings/lib/strings/windows_minimize.locstring.json';
import { windows_Maximize } from 'owa-locstrings/lib/strings/windows_maximize.locstring.json';
import { windows_Close } from 'owa-locstrings/lib/strings/windows_close.locstring.json';
import { WINDOW_ICON_HOST_ID } from 'owa-header-constants';
import { close, toggleMaximize, minimize } from 'owa-client-pie/lib/system.g';
import * as trace from 'owa-trace';

import toggleMaximizeAction from '../actions/toggleMaximize';

import styles from './OneOutlookSuiteHeader.scss';

type WindowIconHostProps = {
    windowId?: string;
    isMaximized: boolean;
};

export const WindowIconHost = React.memo((props: WindowIconHostProps) => {
    const ipcMinimize = React.useCallback(
        () =>
            minimize(props.windowId || '').catch(e => {
                trace.errorThatWillCauseAlert('CouldNotMinimize', e);
            }),
        [props.windowId]
    );
    const ipcMaximize = React.useCallback(() => {
        toggleMaximizeAction(props.windowId, !props.isMaximized);
        toggleMaximize(props.windowId || '').catch(e => {
            trace.errorThatWillCauseAlert('CouldNotToggleMaximize', e);
        });
    }, [props.windowId, props.isMaximized]);
    const ipcClose = React.useCallback(() => {
        toggleMaximizeAction(props.windowId, false);
        close(props.windowId || '').catch(e => {
            trace.errorThatWillCauseAlert('CouldNotClose', e);
        });
    }, [props.windowId]);

    return (
        <div id={WINDOW_ICON_HOST_ID} className={styles.windowIconHost}>
            <IconButton
                onClick={ipcMinimize}
                className={styles.windowIconButton}
                ariaLabel={loc(windows_Minimize)}
                title={loc(windows_Minimize)}
                iconProps={{
                    iconName: SubtractRegular,
                    styles: {
                        root: styles.windowIcon,
                    },
                }}
            />
            <IconButton
                onClick={ipcMaximize}
                className={styles.windowIconButton}
                ariaLabel={loc(windows_Maximize)}
                title={loc(windows_Maximize)}
                iconProps={{
                    iconName: props.isMaximized ? RestoreRegular : MaximizeRegular,
                    styles: {
                        root: styles.windowIcon,
                    },
                }}
            />
            <IconButton
                onClick={ipcClose}
                className={classNames(styles.windowIconButton, styles.close)}
                ariaLabel={loc(windows_Close)}
                title={loc(windows_Close)}
                iconProps={{
                    iconName: DismissRegular,
                    styles: {
                        root: styles.windowIcon,
                    },
                }}
            />
        </div>
    );
});
